/**
 * Created by SH 16/03/2019
 */
import { GameModel } from "@nolimitcity/slot-game/bin/model/GameModel";
import { Presentation } from "./Presentation";
import { PresentationController } from "./PresentationController";
import { GameFlowController } from '@nolimitcity/slot-game/bin/flowcontrol/GameFlowController';
import { FlowState } from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";

export class PresentationManager {
    private dataModel: GameModel<any, any>;
    private gameFlowController: GameFlowController;
    private presentations: PresentationController[] = [];

    constructor(model: GameModel<any, any>, flowController: GameFlowController) {
        this.dataModel = model;
        this.gameFlowController = flowController;
    }

    /**
     * Adds mode controllers for each FlowState in the given presentations map.
     * @param mode - The mode identifier.
     * @param presentations - A map of FlowState to an array of Presentation objects.
     */
    addModeControllers(mode: string, presentations: Map<FlowState, Presentation[]>) {
        const flowStatePresentationMap = new Map<FlowState, PresentationController>();

        presentations.forEach((presentationsArray, state) => {
            const controller = this.addController(presentationsArray, state);
            flowStatePresentationMap.set(state, controller);
        });

        this.gameFlowController.addGameModeFlowStatePresentationMap(mode, flowStatePresentationMap);
    }

    /**
     * Creates a PresentationController for the given presentations and mode state.
     * @param presentations - An array of Presentation objects.
     * @param modeState - The mode state identifier.
     * @returns The created PresentationController.
     */
    addController(presentations: Presentation[], modeState: string): PresentationController {
        const presentationController = new PresentationController(presentations, this.dataModel, modeState);
        this.presentations.push(presentationController);
        return presentationController;
    }

    /**
     * Initializes all presentations.
     */
    initPresentations(): void {
        this.presentations.forEach(presentationController => presentationController.InitPresentations());
    }
}